export const RecipientType = {
  ALL: {
    textCode: 'ALL',
    value: 'ALL',
    icon: 'icon-all-users',
    placeholder: {
      textCode: 'TYPE_TO_FIND_RECIPIENTS',
    },
    emptyMessage: {
      textCode: 'NO_MATCH_RECIPIENTS',
    },
  },
  USERS: {
    textCode: 'USERS',
    value: 'PERSON',
    icon: 'icon-user',
    placeholder: {
      textCode: 'TYPE_TO_FIND_USERS',
    },
    emptyMessage: {
      textCode: 'NO_MATCH_USERS',
    },
  },
  GROUPS: {
    textCode: 'GROUPS',
    value: 'GROUP',
    icon: 'icon-group',
    placeholder: {
      textCode: 'TYPE_TO_FIND_GROUPS',
    },
    emptyMessage: {
      textCode: 'NO_MATCH_GROUPS',
    },
  },
  DYNAMIC_TEAMS: {
    textCode: 'DYNAMIC_TEAMS',
    value: 'DYNAMIC_TEAM',
    icon: 'icon-dynamic-team',
    placeholder: {
      textCode: 'TYPE_TO_FIND_DYNAMIC_TEAMS',
    },
    emptyMessage: {
      textCode: 'NO_MATCH_DYNAMIC_TEAMS',
    },
  },
  DEVICES: {
    textCode: 'DEVICES',
    value: 'DEVICE',
    icon: 'icon-mobile',
    placeholder: {
      textCode: 'TYPE_TO_FIND_DEVICES',
    },
    emptyMessage: {
      textCode: 'NO_MATCH_DEVICES',
    },
  },
  SERVICES: {
    textCode: 'SERVICES',
    value: 'SERVICE',
    icon: 'icon-settings',
    placeholder: {
      textCode: 'TYPE_TO_FIND_DEVICES', // These strings are never used so as a placeholder we will use Devices
    },
    emptyMessage: {
      textCode: 'NO_MATCH_DEVICES', //  These strings are never used so as a placeholder we will use Devices
    },
  },
  SITES: {
    textCode: 'SITES',
    value: 'SITE',
    icon: 'icon-globe',
    placeholder: {
      textCode: 'TYPE_TO_FIND_DEVICES', // These strings are never used so as a placeholder we will use Devices
    },
    emptyMessage: {
      textCode: 'NO_MATCH_DEVICES', //  These strings are never used so as a placeholder we will use Devices
    },
  },
};

export const SearchType = {
  CONTAINS: {
    textCode: 'CONTAINS',
    value: 'CONTAINS',
  },
  STARTS_WITH: {
    textCode: 'STARTS_WITH',
    value: 'STARTS_WITH',
  },
  ENDS_WITH: {
    textCode: 'ENDS_WITH',
    value: 'ENDS_WITH',
  },
  EQUALS: {
    textCode: 'EQUALS',
    value: 'EQUALS',
  },
};

export const ALL_USERS_EMPTY_SEARCH = '   ';

export const DefaultMessagingRecipientTypes = [
  RecipientType.ALL,
  RecipientType.USERS,
  RecipientType.GROUPS,
  RecipientType.DYNAMIC_TEAMS,
  RecipientType.SERVICES,
];

export const GroupMemberRecipientTypes = [
  RecipientType.ALL,
  RecipientType.USERS,
  RecipientType.GROUPS,
  RecipientType.DYNAMIC_TEAMS,
];
